























import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent, useMeta } from '@nuxtjs/composition-api';

import type { ProductTitleData } from '~/modules/catalog/product/types';

export default defineComponent({
  name: 'SimpleProductFixedPanel',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    outOfStock: {
      type: Boolean,
      default: false
    },
    productTitleData: {
      type: Object as PropType<ProductTitleData | null>,
      default: null
    },
    capacity: {
      type: String,
      default: null
    },
    variantName: {
      type: String,
      default: null
    },
    fallbackTitle: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const productTitle = computed<string>(() => {
      return [
        props.productTitleData?.title ?? '',
        props.productTitleData?.description ?? ''
      ]
        .filter(Boolean)
        .join(' - ');
    });

    const productDetails = computed<string>(() => {
      return [
        props.variantName ? props.variantName : '',
        props.capacity ? props.capacity : ''
      ]
        .filter(Boolean)
        .join(' - ');
    });

    const metaTags = computed(() => ({
      bodyAttrs: {
        class: [
          'has-fixed-panel',
          props.active ? 'fixed-panel--active' : '',
          props.outOfStock ? 'fixed-panel--out-of-stock' : ''
        ]
      }
    }));

    useMeta(() => metaTags.value);

    return {
      productTitle,
      productDetails
    };
  },
  head: {}
});
